function Payout() {
  return <div>Payout</div>;
}

export default Payout;
